import { useEffect } from 'react'
import { connect } from 'react-redux'
import * as types from '../../actions/actionTypes'
import { shouldFetchLandingSelector } from '../../reducers/landingReducer'

function LandingUserRoleValidation(props) {
  const { fetchLanding, shouldFetchLanding } = props
  useEffect(() => {
    if (shouldFetchLanding) {
      fetchLanding()
    }
  }, [fetchLanding, shouldFetchLanding])
  return null
}

export default connect(
  state => ({
    shouldFetchLanding: shouldFetchLandingSelector(state.landing),
  }),
  dispatch => ({
    fetchLanding() {
      dispatch({ type: types.START_LANDING_FETCH })
    },
  }),
)(LandingUserRoleValidation)
